module.exports = __webpack_public_path__ + "img/Logo_idip_blanco.07059648.svg";